import React from "react";

const StepsSection = () => {
  return (
    <section className='step py-80'>
      <div className='position-relative z-1'>
        <img
          src='assets/images/shape/curve-line-shape.png'
          alt=''
          className='position-absolute top-0 inset-inline-end-0 z-n1 me-60 d-lg-block d-none'
        />
        <div className='container container-lg'>
          <div className='row gy-4'>
            <div className='col-lg-6'>
              <div className='step-content'>
                <div className='section-heading ms-auto text-end'>
                  <h5 className=''>Start Earning with Zero Investment</h5>
                  <span className='text-gray-600'>
                    Launch your dropshipping store in minutes with access to millions of products from top global marketplaces
                  </span>
                </div>
                <div className='d-flex flex-column align-items-end gap-56'>
                  <div className='d-flex align-items-center gap-32'>
                    <div className='text-end'>
                      <h5 className='mb-8'>Step 01</h5>
                      <p className='text-gray-600'>
                        Register your account and set up your seller profile. Quick verification process.
                      </p>
                    </div>
                    <div className='w-90 h-90 flex-center bg-main-100 rounded-circle'>
                      <h6 className='mb-0 w-60 h-60 bg-main-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        01
                      </h6>
                    </div>
                  </div>
                  <div className='d-flex align-items-center gap-32'>
                    <div className='text-end'>
                      <h5 className='mb-8'>Step 02</h5>
                      <p className='text-gray-600'>
                        Browse and import products from Amazon, AliExpress, Alibaba, Walmart, or eBay to your store.
                      </p>
                    </div>
                    <div className='w-90 h-90 flex-center bg-main-100 rounded-circle'>
                      <h6 className='mb-0 w-60 h-60 bg-main-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        02
                      </h6>
                    </div>
                  </div>
                  <div className='d-flex align-items-center gap-32'>
                    <div className='text-end'>
                      <h5 className='mb-8'>Step 03</h5>
                      <p className='text-gray-600'>
                        Start selling! Orders are automatically fulfilled by suppliers and shipped directly to customers.
                      </p>
                    </div>
                    <div className='w-90 h-90 flex-center bg-main-100 rounded-circle'>
                      <h6 className='mb-0 w-60 h-60 bg-main-600 text-white d-flex align-items-center justify-content-center rounded-circle border border-5 border-white fw-medium'>
                        03
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-lg-6'>
              <div className='text-center'>
                <img src='assets/images/thumbs/steps.png' alt='' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StepsSection;
